import axios from "axios";

export const useCommonApi = () => {
  const apiClient = axios.create({
    baseURL: "https://api365.geoexpress.ge/api",
  });

  apiClient.interceptors.response.use(
    (response) => {
      if (response.data.message === "User not Confirmed") {
        //navigate("/auth-confirmation");
      }
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        // Cookies.remove("Authorization");
        // navigate("/auth-signin");
      }
      return Promise.reject(error);
    }
  );

  return apiClient;
};
